import { useState } from "react";

interface SwitchProps {
  isOn?: boolean; // Initial state
  onChange?: (isOn: boolean) => void; // Callback for state changes
}

function Switch({ isOn = false, onChange }: SwitchProps) {
  const [isChecked, setIsChecked] = useState(isOn);

  const toggleSwitch = () => {
    setIsChecked(!isChecked);
    if (onChange) onChange(!isChecked);
  };

  // Handle key down to support space bar for toggle
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault(); // Prevent scrolling when pressing spacebar
      toggleSwitch(); // Toggle the switch when space or enter is pressed
    }
  };

  return (
    <div
      className="relative"
      onClick={toggleSwitch}
      onKeyDown={handleKeyDown} // Handle spacebar or enter press
    >
      <span
        role="switch"
        aria-checked={isChecked}
        aria-label="Switch button"
        tabIndex={0}
        className={`rounded-full flex items-center cursor-pointer w-12 h-6 transition-all duration-200 relative z-0 ${
          isChecked ? " bg-[#DEDDF7] dark:bg-[#DEDDF7] " : "bg-stone-300 "
        }`}
      >
        <span
          aria-hidden="true"
          className={`rounded-full w-5 h-5  transition-all duration-200 ${
            isChecked
              ? "translate-x-[26px] bg-[#352FC3] dark:bg-[#A39FE8]"
              : "translate-x-0.5 bg-white"
          }`}
        ></span>
      </span>
    </div>
  );
}

export default Switch;
